"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarRadioButtonStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarRadioButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    selected: {
        sj55zd: "f16muhyy"
    }
}, {
    d: [
        ".f16muhyy{color:var(--colorBrandForeground1);}"
    ]
});
const useToolbarRadioButtonStyles_unstable = (state)=>{
    (0, _reactbutton.useToggleButtonStyles_unstable)(state);
    const toggleButtonStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.root.className, state.checked && toggleButtonStyles.selected);
    return state;
}; //# sourceMappingURL=useToolbarRadioButtonStyles.styles.js.map
